
import { defineComponent } from 'vue'
import { NDescriptions, NDescriptionsItem } from 'naive-ui';
import { mapState } from 'pinia';

import { useAuthStore } from "~/store/auth.store";

export default defineComponent({
    components: {
        NDescriptions,
        NDescriptionsItem,
    },

    computed: {
        ...mapState(useAuthStore, ['user']),
    }
})
